import { useRef, useState } from 'react';
import { Pause, Play, PlusCircle, Repeat, SkipBack, SkipForward } from 'lucide-react';
import ProgressBar from './ProgressBar';

const AlbumTable = ({ titles }) => {
  
  const [currentTrackId, setCurrentTrackId] = useState(null);
  const [hoveredTrackId, setHoveredTrackId] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [trackPlaybackPositions, setTrackPlaybackPositions] = useState({});
  const audioRef = useRef(null);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setTrackPlaybackPositions((prev) => ({
        ...prev,
        [currentTrackId]: audioRef.current.currentTime,
      }));
    }
  };

  const togglePlayPause = (trackId, srcc) => {
    if (audioRef.current) {
      if (isPlaying && currentTrackId === trackId) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        if (currentTrackId !== null && currentTrackId !== trackId) {
          setTrackPlaybackPositions((prev) => ({
            ...prev,
            [currentTrackId]: audioRef.current.currentTime,
          }));
          audioRef.current.pause();
        }
        audioRef.current.src = srcc;
        audioRef.current.currentTime = trackPlaybackPositions[trackId] || 0;
        audioRef.current.play();
        setCurrentTrackId(trackId);
        setIsPlaying(true);
      }
    }
  };

  return (
    <>
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-700">
            <th className="text-left py-3 px-5 text-gray-400 font-normal w-12">#</th>
            <th className="text-left py-3 px-4 text-gray-400 font-normal flex-grow">Title</th>
            <th className="text-left py-3 px-4 text-gray-400 font-normal w-24">Duration</th>
          </tr>
        </thead>
        <tbody>
          {titles.map((track, index) => (
            <tr
              key={track.id}
              className={`hover:bg-midnight transition duration-200 ${
                currentTrackId === track.id ? 'bg-charcoal' : ''
              }`}
              style={{ width: '600px' }}
              onMouseEnter={() => setHoveredTrackId(track.id)}
              onMouseLeave={() => setHoveredTrackId(null)}
            >
              <td className="py-3 px-4 text-gray-400 w-12" style={{ width: '60px' }}>
                {hoveredTrackId === track.id || currentTrackId === track.id ? (
                  <button
                    onClick={() => togglePlayPause(track.id, track.audio_src)}
                    className="hover:text-green-500 flex items-center justify-center w-full"
                  >
                    {isPlaying && currentTrackId === track.id ? (
                      <Pause className="w-4 h-4 sm:w-4 sm:h-4" />
                    ) : (
                      <Play className="w-1 h-4 sm:w-4 sm:h-4" />
                    )}
                  </button>
                ) : (
                  <span className="flex items-center justify-center w-full">{index + 1}</span>
                )}
              </td>
              <td className="py-3 px-4 font-medium flex-grow w-full">
                {hoveredTrackId === track.id || currentTrackId === track.id ? (
                  <div className="flex items-center justify-center">
                    <div className="flex gap-1 sm:gap-2 mx-1 sm:mx-2">
                      <Repeat className="w-4 h-4 sm:w-5 sm:h-5" />
                      <SkipBack className="w-4 h-4 sm:w-5 sm:h-5" />
                    </div>
                    <ProgressBar currentTime={trackPlaybackPositions[track.id]} className="w-full" />
                    <div className="flex gap-1 sm:gap-2 mx-1 sm:mx-2">
                      <SkipForward className="w-4 h-4 sm:w-5 sm:h-5" />
                      <PlusCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                    </div>
                  </div>
                ) : (
                  track.title
                )}
              </td>
              <td className="py-3 px-4 text-gray-400 w-24">
                {hoveredTrackId === track.id || currentTrackId === track.id ? (
                  <span>{formatTime(Math.floor(trackPlaybackPositions[track.id] || 0))}</span>
                ) : (
                  track.duration
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <audio
        ref={audioRef}
        onTimeUpdate={handleTimeUpdate}
        onEnded={() => {
          setIsPlaying(false);
          setCurrentTrackId(null);
        }}
      ></audio>
    </>
  );
};

export default AlbumTable;